























import {computed, defineComponent} from "@vue/composition-api";

export default defineComponent({
  props: {
    rounded: {
      type: Boolean,
      required: false,
      default: true,
    },
    bordered: {
      type: Boolean,
      required: false,
      default: false,
    },
    themed: {
      type: Boolean,
      required: false,
      default: false,
    },
    effectShadow: {
      type: Boolean,
      required: false,
      default: true,
    },
    effectPop: {
      type: Boolean,
      required: false,
      default: false,
    },
    effectRotateRight: {
      type: Boolean,
      required: false,
      default: false,
    },
    effectRotateLeft: {
      type: Boolean,
      required: false,
      default: false,
    },
    transparent: {
      type: Boolean,
      required: false,
      default: false,
    },
    effectLinkRotate: {
      type: Boolean,
      required: false,
      default: false,
    },
    effectLinkPop: {
      type: Boolean,
      required: false,
      default: false,
    },
    effectLinkShadow: {
      type: Boolean,
      required: false,
      default: false,
    },
    loading: {
      type: Boolean,
      required: false
    },
    title: {
      type: String,
      required: false
    },
    subtitle: {
      type: String,
      required: false
    },
    icon: {
      type: String,
      required: false
    },
    enableFullscreenOption: {
      type: Boolean,
      default: false
    },
    enablePinOption: {
      type: Boolean,
      default: false
    },
    enableCollapseOption: {
      type: Boolean,
      default: false
    },
    headerClasses: {
      type: [String, Array, Object],
      required: false
    },
    contentClasses: {
      type: [String, Array, Object],
      required: false
    },
  },
  setup(props, {slots}) {
    const classes = computed(() => {
      return {
        'block-rounded': props.rounded,
        'block-bordered': props.bordered,
        'block-themed': props.themed,
        'block-fx-shadow': props.effectShadow && !props.bordered,
        'block-fx-pop': props.effectPop,
        'block-fx-rotate-right': props.effectRotateRight,
        'block-fx-rotate-left': props.effectRotateLeft,
        'block-transparent': props.transparent,
        'block-link-rotate': props.effectLinkRotate,
        'block-link-pop': props.effectLinkPop,
        'block-link-shadow': props.effectLinkShadow,
        'block-mode-loading': props.loading
      }
    });

    const displayOptionsSlot = computed(() => {
      return slots.options || props.enableCollapseOption || props.enablePinOption || props.enableCollapseOption;
    });

    const displayHeaderSlot = computed(() => {
      return displayOptionsSlot.value === true || props.title || slots.title;
    });

    const footerShow = computed(() => {
      return !!slots.footer;
    });
    return {
      classes,
      displayHeaderSlot,
      displayOptionsSlot,
      footerShow,
    }
  }
});
